export class DH{
  
  DivisionalHospitalId: number;
  DivisionalHospitalName: string;
  Contact : string;
  DistrictId : number;
  Address: string;
  Phone : string;
  UserName : string;
  Password : string;
   Referrals:[
     {
      Diagnosis:any
     }
   ]
  DHUsers: [
    {
      //  "DHQUserId":56,
      //  "DHQLoginId":"d19a2835-74f5-466f-85d7-33b67cf26983",
      //  "Name":"Eye",
      //  "UserName":"EYE-DHQ-RWP-024",
      //  "Password":"bpbi",
      //  "UserType":"Eye",
      UserName : string;
  Password : string;
      colorr:string; 
      ReferredPatients:any,
       DuePatients:any,
       NCPPatients:any,
       NonAttendedPatients:any,
       AttendedPatients:any,
      //  IsDhqUserActive:true,
    }
  ]
  DivisionalHospitalUserId: number;
  Name: string;
  IsActive:boolean;
  ScheduledDays: [
    {
    ScheduledDayId : any;
    IsScheduled: any;
    }
  ];
  DistrictName: any;
}

export class DH1{

  PatientName:any
  Father_Husband_Name:any
  CNIC :any
  LastStatusUpdatedAt:any
  DOB:any
  NCDRegistrationNumber:any
  Address:any
  Contact:any
  Gender:any
  Status:any
  DHName:any
  Referrals:[
    {
     Diagnosis:any
    }
  ]
}

